import TrustPilotBanner from './TrustPilotBanner'

const TrustPilotBannerWrapper = ({ moduleData, ...rest }: any) => {
  return <TrustPilotBanner moduleData={moduleData} {...rest} />
}

export default TrustPilotBannerWrapper
